/** @jsxRuntime classic */
/** @jsx jsx */
import React from 'react';
import { jsx } from 'theme-ui';
import Text from './Text';

/**
 *
 * @param {{
 * children: React.ReactNode;
 * variant?: import('./pVariants').PVariants
 * }} props
 * @returns
 */
export default function P({ children, variant = 'default', ...rest }) {
  return (
    <Text
      as="p"
      // @ts-ignore We pass in another set of variants, so this is ok.
      variant={variant}
      variants="p"
      {...rest}
    >
      {children}
    </Text>
  );
}
